<template>
  <div>
    <!-- section start -->
    <section>
      <div class="inner row3_1 flex mobileFlexCol">
        <article class="wd100">
          <div class="advisoryManagement">
            <h1 class="mainTitle">직접 자문 관리</h1>

            <article class="aRow2">
              <h3 class="alignL statusMatchingTitle">
                매칭 현황
              </h3>
              <section class="flex  statusMatchingRow">
                <div
                  class="statusMatchingItem"
                  v-for="(item, index) in statusMatchingItems"
                  :key="index"
                >
                  <div class="boxText">
                    <h4 class="boxTextTitle">{{ item.title }}</h4>
                    <h2
                      class="boxTextNumber"
                      :style="{ color: item.textColor }"
                    >
                      {{ item.number }} 건
                    </h2>
                  </div>

                  <figure class="image">
                    <img :src="item.icon" :alt="item.title" />
                  </figure>

                  <div
                    class="lineBottom"
                    :style="{ backgroundColor: item.lineColor }"
                  ></div>
                </div>
              </section>
            </article>

            <article class="aRow2 nap">
              <h3 class="alignL statusMatchingTitle">
                NAP 매칭 목록
              </h3>

              <div class="selectOption">
                <SelectOption
                  v-model="status"
                  :options="options"
                  :handleChangeOption="loadNapList"
                />
              </div>

              <div class="napaLists">
                <h5 v-if="napMatchingHistoryList.length == 0">
                  There is no data to show
                </h5>
                <ItemAdminNapMatching
                  v-for="(item, index) in napListFiter"
                  :item="item"
                  :key="index"
                  @openModal="handleOpenModal"
                />
              </div>
            </article>

            <PaginationMatching
              :rows="napMatchingHistoryList.length"
              :page.sync="page"
              :perPage="itemPerPage"
              @update:page="handleChangePage"
            />
          </div>
        </article>
      </div>

      <NapWritPopup
        :isOpenModalNap="isOpenModalNap"
        :data="selectedNapMatching"
        :handleToggleModalNap="handleCloseModal"
        @onReply="handleReply"
      />
    </section>
  </div>
</template>
<script>
import ItemAdminNapMatching from "@/components/items/ItemAdminNapMatching.vue";
import NapWritPopup from "@/components/matching/popup/NapWritPopup.vue";
import PaginationMatching from "@/components/general/PaginationMatching.vue";
import SelectOption from "@/components/formControl/SelectOption.vue";
import { mapActions, mapState } from "vuex";
import { napMatchingStatusOptions, napStatus } from "@/data/constances";

export default {
  name: "NapAdvisoryManagement",
  components: {
    SelectOption,
    PaginationMatching,
    ItemAdminNapMatching,
    NapWritPopup,
  },
  computed: {
    ...mapState("matching", ["selectedNapMatching"]),
    ...mapState("napMatchingHistory", ["napMatchingHistoryList", "statistic"]),
    napList() {
      return this.napMatchingHistoryList
        .filter((item) =>
          [napStatus.APPROVED, napStatus.PENDING].includes(item.status)
        )
        .slice(
          (this.page - 1) * this.itemPerPage,
          this.page * this.itemPerPage
        );
    },
  },
  data() {
    return {
      options: napMatchingStatusOptions,
      page: 1,
      itemPerPage: 5,
      status: "",
      statusMatchingItems: [
        {
          id: 1,
          title: "총 신청 수",
          number: "0",
          icon: "/images/manager/matching/docs.svg",
          lineColor: "#8D98C8",
          textColor: "#26336A",
        },
        {
          id: 1,
          title: "자문 대기",
          number: "0",
          icon: "/images/manager/matching/community.svg",
          lineColor: "#B1DF8D",
          textColor: "#3F7416",
        },
        {
          id: 1,
          title: "자문 완료",
          number: "0",
          icon: "/images/manager/matching/user.svg",
          textColor: "#2B939A",
          lineColor: "#70CED4",
        },
      ],
      isOpenModalNap: false,
      napListFiter: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions("matching", ["napDetail"]),
    ...mapActions("napMatchingHistory", [
      "loadNapMatchingHistoryByStatus",
      "getNapMatchingStatistic",
      "loadAllNapMatchingHistory",
    ]),
    getData() {
      var that = this;
      this.loadAllNapMatchingHistory().then(() => {
        that.loadNapList();
      });
    },
    async handleOpenModal(item) {
      await this.napDetail(item.idx);
      this.isOpenModalNap = true;
    },
    handleChangePage(page) {
      this.page = page;
      this.loadNapList();
    },
    loadNapList() {
      const that = this;
      const deep = that.lodash.cloneDeep(this.napMatchingHistoryList);
      let array_filter = [];
      if (that.lodash.isEmpty(that.status)) {
        array_filter = deep;
      } else {
        array_filter = that.lodash.filter(deep, function(o) {
          return o.status == that.status;
        });
      }
      that.napListFiter = array_filter.slice(
        (that.page - 1) * that.itemPerPage,
        that.page * that.itemPerPage
      );
    },
    handleCloseModal() {
      this.isOpenModalNap = false;
    },
    handleReply(data) {
      this.$store.dispatch("matching/napUpdate", data).finally(() => {
        this.handleCloseModal();
        this.getData();
      });
    },
  },
  watch: {
    napMatchingHistoryList: {
      handler(val) {
        this.statusMatchingItems[0].number = val.length;
        this.statusMatchingItems[1].number = this.lodash.filter(val, function(
          o
        ) {
          return o.status == napStatus.PENDING;
        }).length;
        this.statusMatchingItems[2].number = this.lodash.filter(val, function(
          o
        ) {
          return o.status == napStatus.APPROVED;
        }).length;
      },
      deep: true,
    },
  },
};
</script>
<style scoped lang="scss">
.advisoryManagement {
  .advisoryManagementTitle {
    color: #9e1915;
    text-align: center;
  }

  .statusMatchingTitle {
    color: #26336a;
  }

  .statusMatchingRow {
    padding-top: 40px;
    gap: 0 6rem;
    justify-content: center;
  }

  .statusMatchingItem {
    width: 240px !important;
    height: 302px !important;
    background: #ffffff !important;
    border: 1px solid #ededed;
    border-radius: 10px;
    position: relative;
    overflow: hidden;

    .boxText {
      text-align: center;
      padding-top: 37px;

      .boxTextTitle {
        color: #6c6c6c;
      }

      .boxTextNumber {
        color: #26336a;
      }
    }

    .image {
      padding-top: 30px;
      height: 90px;
    }

    .lineBottom {
      position: absolute;
      height: 16px;
      width: 100%;
      background-color: #8d98c8;
      bottom: 0;
    }
  }

  .mainTitle {
    &::after {
      display: none !important;
    }
  }
}

.nap {
  .selectOption {
    display: flex;
    justify-content: flex-end;
    border-bottom: 1px solid #d6d6d6;
    margin-bottom: 24px;
    padding-bottom: 12px;
  }
}
</style>
